/**
 * Maps backend function names to user-friendly display names
 */

const FiltersToDisplayNames = {
  multi_sample_analysis_filter: 'Multi-Sample Analysis',
  gene_filter: 'Gene Filter',
  chromosome_filter: 'Chromosome Filter',
  position_filter: 'Position Filter',
  genotype_filter: 'Genotype Filter',
  in_dbsnp_filter: 'dbSNP Filter',
  genesus_frequency_filter: 'Genesus Frequency',
  KG_frequency_filter: '1000 Genomes Frequency',
  GnomAD_Exome_frequency_filter: 'GnomAD Exome Frequency',
  GnomAD_Genome_frequency_filter: 'GnomAD Genome Frequency',
  ExAC_frequency_filter: 'ExAC Frequency',
  TurkishVariome_frequency_filter: 'Turkish Variome Frequency',
  Alfa_Total_frequency_filter: 'ALFA Frequency',
  Variant_Calling_Filter: 'Variant Calling Filter',
  Quality_Score_filter: 'Quality Score Filter',
  Strand_Bias_filter: 'Strand Bias Filter',
  impact_filter: 'Impact Filter',
  in_omim_filter: 'OMIM Filter',
  CADD_Phred_filter: 'CADD Score Filter',
  DANN_score_filter: 'DANN Score Filter',
  MetalR_score_filter: 'MetaLR Score Filter',
  PolyPhen_score_filter: 'PolyPhen Score Filter',
  SIFT_score_filter: 'SIFT Score Filter',
  AlphaMissense_score_filter: 'AlphaMissense Score Filter',
  ACMG_filter: 'ACMG Classification Filter',
  ClinVar_filter: 'ClinVar Filter',
  panel_filter: 'Gene Panel Filter',
  disease_filter: 'Disease Filter',
  HPO_filter: 'HPO Phenotype Filter',
  Read_Depth_filter: 'Read Depth Filter',
  Allelic_Balance_filter: 'Allelic Balance Filter',
}

const ToolsToDisplayNames = {
  search_web: 'Search Web',
  get_sample_data: 'Get Sample Data',
  edit_hpos: 'Edit HPOs',
  ask_for_clarification: 'Ask for Clarification',
  get_genesus_filter: 'Get Genesus Filter',
  get_genesus_filter_descriptions: 'Get Genesus Filter Descriptions',
  filter_genesus_filters: 'Filter Genesus Filters',
  plan_filter_for_sample: 'Plan Filter for Sample',
  get_current_filters_of_sample: 'Get Current Filters of Sample',
  create_report: 'Create Report',
  check_report: 'Check Report',
  get_guideline: 'Get Guideline',
}

/**
 * Gets the display names for all functions
 * @returns {Object} Object with function names as keys and display names as values
 */
export const functionDisplayNames = {
  ...FiltersToDisplayNames,
  ...ToolsToDisplayNames,
}

/**
 * Gets the editable functions
 * @returns {string[]} Array of editable function names
 */
export const editableFunctions = [...Object.keys(FiltersToDisplayNames), 'edit_hpos']

/**
 * Gets the display name for a function
 * @param {string} functionName - The backend function name
 * @returns {string} User-friendly display name or the original name if no mapping exists
 */
export const getFunctionDisplayName = (functionName) => {
  return functionDisplayNames[functionName] || functionName
}

/**
 * Formats filter values from backend format to display format
 * @param {string} value - The backend value (e.g., "likely_pathogenic")
 * @returns {string} Formatted display value (e.g., "Likely Pathogenic")
 */
export const formatFilterValue = (value) => {
  if (!value) return value

  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
